import styled from "styled-components";

export const HagahPage = styled.main`
  min-height: 100vh;
  overflow-x: hidden;
  color: #ffffff;
  background: #0b0b0b;
`;

export const ArtworkStage = styled.div`
  position: relative;
  width: min(100%, 1440px);
  margin: 0 auto;
`;

export const ArtworkImage = styled.img`
  display: block;
  width: 100%;
  height: auto;
`;

const HitArea = styled.a`
  position: absolute;
  z-index: 2;
  top: 0.7%;
  display: block;
  min-height: 32px;
  color: transparent;
  background: transparent;
  border: 0;
  border-radius: 6px;
  font-size: 0;
  text-decoration: none;

  span {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  &:focus-visible {
    outline: 2px solid #ffffff;
    outline-offset: 4px;
  }
`;

export const BackHitArea = styled(HitArea)`
  left: 4%;
  width: 18%;
  height: 2.4%;
`;

export const SupportHitArea = styled(HitArea)`
  right: 4%;
  width: 14%;
  height: 2.4%;
`;

export const ScreenReaderSummary = styled.div`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;
